export default __webpack_public_path__ + "static/media/CTAImageGuestAnon.f757e21c.jpg";